export default __webpack_public_path__ + "static/media/Gwalior2.576b2b30.jpg";